/** Default pooling interval for player registration-status polling (ms). Used when the API does not provide one. */
export const PLAYER_POOLING_PERIOD_MS = 30 * 1000

/**
 * Fast unregistered pairing poll (ms). Used for the first
 * {@link PLAYER_POOLING_UNREGISTERED_FAST_WINDOW_MS} so operators see the QR update quickly.
 */
export const PLAYER_POOLING_PERIOD_WHILE_UNREGISTERED_MS = 2 * 1000

/** Keep the fast 2s cadence for this long after becoming unregistered (pairing UX). */
export const PLAYER_POOLING_UNREGISTERED_FAST_WINDOW_MS = 3 * 60 * 1000

/** Mid backoff after the fast window (still responsive, lower API load). */
export const PLAYER_POOLING_UNREGISTERED_MID_MS = 12 * 1000

/** After this duration unregistered, use the slow cadence. */
export const PLAYER_POOLING_UNREGISTERED_MID_UNTIL_MS = 30 * 60 * 1000

/** Slow cadence for long-lived orphaned / unregistered devices. */
export const PLAYER_POOLING_UNREGISTERED_SLOW_MS = 45 * 1000

/**
 * Wait for HTTP pooling handoff (or WS reconnect) before opening an offline incident.
 * One default poll interval plus startup slack (PoolingService debounce + first fetch).
 */
export const PLAYER_OFFLINE_INCIDENT_GRACE_MS = PLAYER_POOLING_PERIOD_MS + 5_000
